import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"edit\">\r\n<path d=\"M3 17.2505V21H6.74948L17.8079 9.94154L14.0585 6.19206L3 17.2505ZM20.7075 7.04194C21.0975 6.65199 21.0975 6.02208 20.7075 5.63213L18.3679 3.29246C17.9779 2.90251 17.348 2.90251 16.9581 3.29246L15.1283 5.12221L18.8778 8.87168L20.7075 7.04194Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol